import { z } from "zod";
import { ShortText, ImageSrcText } from "./common.js";
/**
 * Image card — Hoshin canvas Yjs-native (PB-234). Holds either a hosted image
 * URL or an inline `data:` URI from an in-canvas upload, so `url` uses the
 * large `ImageSrcText` bound (NOT `MediumText`, whose 500-char cap would reject
 * any real data URI and coerce the card to blank via `paramsFromY`). Empty is
 * valid — a freshly-added card shows the URL input. The http(s)/`data:image/`
 * scheme guard (`isSafeHttpUrl` / `isDisplayableImage`, packages/ui) is the
 * render-time safety gate, not the schema. `alt` is author-supplied accessible
 * text.
 */
export const ImageParamsSchema = z
    .object({
    url: ImageSrcText,
    alt: ShortText,
})
    .strict();
export const defaultImageParams = {
    url: "",
    alt: "",
};
/** Entity-backed Image tile: bytes live in object storage, params hold a URL. */
function isHostedHttpsUrl(value) {
    if (!/^https:\/\/[^/?#]+(?:[/?#]|$)/i.test(value))
        return false;
    try {
        const parsed = new URL(value);
        return parsed.protocol === "https:" && parsed.hostname.length > 0;
    }
    catch {
        return false;
    }
}
export const ImageTileParamsSchema = ImageParamsSchema.refine(({ url }) => url === "" || isHostedHttpsUrl(url), { message: "url must be empty or a hosted HTTPS image URL", path: ["url"] });
export const defaultImageTileParams = defaultImageParams;
//# sourceMappingURL=image.js.map